import { useRouter } from "next/router";
import { useTranslator } from "@eo-locale/react";

import { Image } from "@/storybook-components";
import { buildImgixUrl } from "@/lib";
import { useAppSelector } from "@/redux/store/hooks";

const ImageBanner = () => {
  const { translate } = useTranslator();
  const { pathname } = useRouter();
  const projectBannerUrl = useAppSelector(
    (state) => state.project?.project?.bannerUrl
  );
  const projectBannerCaption = useAppSelector(
    (state) => state.project?.project?.bannerCaption
  );
  const { bannerUrl, displayProjectBanner, displaySiteBanner, bannerCaption } =
    useAppSelector((state) => state.site?.site);

  let bannerImageUrl;
  let bannerAlttext;
  let bannerDatatestId;
  if (displayProjectBanner && projectBannerUrl) {
    bannerImageUrl = projectBannerUrl;
    bannerAlttext = projectBannerCaption || translate("common.projectBanner");
    bannerDatatestId = "project-banner-image";
  } else if (displaySiteBanner && bannerUrl) {
    bannerImageUrl = bannerUrl;
    bannerAlttext = bannerCaption || translate("common.siteBanner");
    bannerDatatestId = "site-banner-image";
  }

  /*
    In the future, the value of tools can be changed to match the tool names
    through /\/(surveys|brainstormers)\// that 
    require an image banner.
  */
  const tools = /\/(surveys)\//;
  const isImageBannerNeeded = pathname && pathname.match(tools);

  return isImageBannerNeeded && isImageBannerNeeded[0] && bannerImageUrl ? (
    <Image
      alt={bannerAlttext}
      src={buildImgixUrl(bannerImageUrl)}
      data-testid={bannerDatatestId}
      borderRadius="none"
      width="full"
    />
  ) : null;
};

export default ImageBanner;
